<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 13 14"
    enable-background="new 0 0 13 14"
    xml:space="preserve"
    class="icon icon--box"
    fill="currentColor"
  >
    <path
      d="M6.5,13.9c-0.1,0-0.3,0-0.4-0.1l-5.2-3.1c-0.2-0.1-0.4-0.4-0.4-0.6V3.9c0-0.3,0.1-0.5,0.4-0.6l5.2-3.1
	c0.2-0.1,0.5-0.1,0.8,0l5.2,3.1c0.2,0.1,0.4,0.4,0.4,0.6v6.1c0,0.3-0.1,0.5-0.4,0.6l-5.2,3.1C6.8,13.8,6.6,13.9,6.5,13.9z M2,9.6
	l4.5,2.6L11,9.6V4.4L6.5,1.7L2,4.4V9.6z"
    />
    <rect x="5.8" y="7" width="1.5" height="6.1" />
    <rect
      x="3.1"
      y="2.4"
      transform="matrix(0.5047 -0.8633 0.8633 0.5047 -2.7989 6.0522)"
      width="1.5"
      height="6.1"
    />
    <rect
      x="6.1"
      y="4.7"
      transform="matrix(0.8634 -0.5046 0.5046 0.8634 -1.5109 5.3513)"
      width="6.1"
      height="1.5"
    />
    <rect
      x="3.2"
      y="3.2"
      transform="matrix(0.8634 -0.5046 0.5046 0.8634 -1.1344 3.6723)"
      width="6.1"
      height="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'BoxIcon',
}
</script>
